import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './BoxSelector.css';

const BoxSelector = ({ onSelect, selectedBox, disabled = false }) => {
  const [hoveredBox, setHoveredBox] = useState(null);
  const boxes = [1, 2, 3, 4, 5, 6, 7];

  const boxVariants = {
    initial: { 
      scale: 0,
      rotateY: -180,
      opacity: 0
    },
    animate: (index) => ({
      scale: 1,
      rotateY: 0,
      opacity: 1,
      transition: {
        delay: index * 0.1,
        duration: 0.6,
        type: 'spring',
        stiffness: 200,
        damping: 20
      }
    }),
    hover: {
      scale: 1.08,
      y: -10,
      transition: { duration: 0.2 }
    },
    tap: {
      scale: 0.95,
      transition: { duration: 0.1 }
    },
    selected: {
      scale: 1.1,
      y: -15,
      boxShadow: '0 20px 40px rgba(212, 164, 42, 0.4)',
      transition: { duration: 0.3 }
    }
  };

  const lidVariants = {
    closed: { rotateX: 0 },
    open: { 
      rotateX: -120,
      transition: { duration: 0.4, ease: 'easeOut' }
    }
  };

  const handleBoxClick = (boxNumber) => {
    if (!disabled) {
      onSelect(boxNumber);
    }
  };

  return (
    <div className="box-selector">
      <div className="boxes-container">
        {boxes.map((boxNumber, index) => (
          <motion.div
            key={boxNumber}
            className={`mystery-box ${selectedBox === boxNumber ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
            variants={boxVariants}
            initial="initial"
            animate={selectedBox === boxNumber ? 'selected' : 'animate'}
            whileHover={!disabled && selectedBox !== boxNumber ? 'hover' : undefined}
            whileTap={!disabled ? 'tap' : undefined}
            custom={index}
            onClick={() => handleBoxClick(boxNumber)}
            onMouseEnter={() => setHoveredBox(boxNumber)}
            onMouseLeave={() => setHoveredBox(null)}
          >
            <div className="box-glow" />
            
            <div className="box-body">
              <motion.div 
                className="box-lid"
                variants={lidVariants}
                animate={hoveredBox === boxNumber && !disabled ? 'open' : 'closed'}
              >
                <div className="lid-top">
                  <div className="lid-ribbon" />
                </div>
              </motion.div>
              
              <div className="box-content">
                <span className="box-question">?</span>
              </div>
              
              <div className="box-front">
                <div className="box-ribbon-vertical" />
                <div className="box-ribbon-horizontal" />
              </div>
            </div>
            
            <div className="box-label">
              <span className="box-number">Box {boxNumber}</span>
            </div>
            
            <AnimatePresence>
              {selectedBox === boxNumber && (
                <motion.div
                  className="selected-indicator"
                  initial={{ scale: 0, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0, opacity: 0 }}
                >
                  ✓
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
      
      {selectedBox && (
        <motion.p
          className="selection-text"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
        >
          You selected <strong>Box {selectedBox}</strong>
        </motion.p>
      )}
    </div>
  );
};

export default BoxSelector;

